module.exports = __webpack_public_path__ + "img/red_packet_x4.b7fba077.png";